module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-services"
  }, [_c('img', {
    attrs: {
      "id": "btn_udesk_im",
      "src": "/static/images/kefu1.png"
    },
    on: {
      "click": _vm.OpenCustomerServices
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d37c1512"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/customer-services.vue
// module id = 570
// module chunks = 221